import { render, staticRenderFns } from "./examInfo.vue?vue&type=template&id=6a8bff06"
import script from "./examInfo.vue?vue&type=script&lang=js"
export * from "./examInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports